/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat1_BodyInputs */

const es_l7_feat1_body = /** @type {(inputs: L7_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitamos el cambio de uso, el despacho y el rol de la tripulación ante la autoridad marítima.`)
};

const gl_l7_feat1_body = /** @type {(inputs: L7_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitamos o cambio de uso, o despacho e o rol da tripulación ante a autoridade marítima.`)
};

const en_l7_feat1_body = /** @type {(inputs: L7_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We process the change of use, dispatch and crew role with the maritime authority.`)
};

/**
* | output |
* | --- |
* | "We process the change of use, dispatch and crew role with the maritime authority." |
*
* @param {L7_Feat1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat1_body = /** @type {((inputs?: L7_Feat1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat1_body(inputs)
	if (locale === "en") return en_l7_feat1_body(inputs)
	return es_l7_feat1_body(inputs)
});